import { actions } from './actions'

const initialState = {
  data: [],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_TOURS_RESULT:
      return { ...state, data: action.payload }
    default:
      return state
  }
}
